import Apple from '../icons/apple.svg';
import Base from '../icons/base.svg';
import Envelope from '../icons/envelope.svg';
import Google from '../icons/google.svg';
import Phone from '../icons/phone.svg';
import Telegram from '../icons/telegram.svg';
import X from '../icons/x.svg';
import { AuthMethod, AuthMethodConfig, AuthMethodData, authMethodDataKey } from '../types';

export const authMethodOptions: Partial<Record<AuthMethod, AuthMethodConfig>> = {
  email: {
    value: 'email',
    label: 'Email',
    icon: Envelope,
  },
  sms: {
    value: 'sms',
    label: 'SMS',
    icon: Phone,
  },
  'oauth:google': {
    value: 'oauth:google',
    label: 'Google',
    icon: Google,
  },
  'oauth:apple': {
    value: 'oauth:apple',
    label: 'Apple',
    icon: Apple,
  },
  'oauth:x': {
    value: 'oauth:x',
    label: 'X',
    icon: X,
  },
  'oauth:telegram': {
    value: 'oauth:telegram',
    label: 'Telegram',
    icon: Telegram,
  },
  'siwe:base': {
    value: 'siwe:base',
    label: 'Base',
    icon: Base,
  },
};

export function getAuthMethodData(method?: AuthMethod): AuthMethodData {
  return {
    [authMethodDataKey]: true,
    authMethodId: method,
  };
}

export function isAuthMethodData(data: Record<string | symbol, unknown>): data is AuthMethodData {
  return data[authMethodDataKey] === true;
}

export function isAuthMethod(value: string): value is AuthMethod {
  return !!authMethodOptions[value as AuthMethod];
}
